import React from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { certificates } from "../Models";

function Certificates() {
  return (

    <div class="card">
    <div class="card-header" style={{textAlign:"left"}}>
      <h3>Certificates</h3>
    </div>
    <Row style={{ justifyContent: "center", padding: "10px" }}>
      {certificates.map((certificate) => (
        <Col md={4} className="certificate-card">
            <Card className="certificate-card-view">
            <a href={certificate.link} style={{color:"black"}}><Card.Img variant="top" className='certificate_card_img' src={certificate.image} alt="card-img" />
            <Card.Body>
              <div className='project-desc'>
              <Card.Title style={{fontWeight:"bold"}}>{certificate.title}</Card.Title>
              </div>
            
              
            </Card.Body>
            </a>
          </Card>
        </Col>
          ))}
    </Row>
  
  
  </div>
  );
}

export default Certificates;
